import { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import DataTable from 'react-data-table-component';
import { MdDelete, MdEdit, MdAttachMoney } from 'react-icons/md';
import styles from './nomina.module.css';
import { api } from '../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../utils/layout/windowsLayout';
import Select from 'react-select';
import NominaModal from './nominaModal';
import { Flex } from 'antd';

export default function Nomina(props) {
    const { setMenuActual } = useAuth();

    const [sucursales, setSucursales] = useState([]);
    const [sucursalSelect, setSucursalSelect] = useState(null);
    const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
    }).split('/').reverse().join('-'));
    const [loading, setLoading] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);
    const [detailData, setDetailData] = useState([]);
    const [selectedAdvisor, setSelectedAdvisor] = useState(null);
    const [asesoresMap, setAsesoresMap] = useState({});
    const [selectedAdvisorId, setSelectedAdvisorId] = useState(null);

    const handleGetSucursales = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data && data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });
                    }
                }
                setSucursales(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleGetAsesores = () => {
        api(SERVICE.getAsesoresAll)
            .then((data) => {
                let mapTemp = {};
                if (data.data && data.data.data) {
                    data.data.data.forEach((element) => {
                        if (element.alias) {
                            mapTemp[element.alias.toLowerCase()] = element.id;
                        }
                        if (element.firstName && element.lastName) {
                            const fullName = `${element.firstName} ${element.lastName}`.toLowerCase();
                            mapTemp[fullName] = element.id;
                        }
                    });
                }
                setAsesoresMap(mapTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleUpdate = useCallback(() => {
        if (fecha !== '' && fecha !== null && sucursalSelect !== null) {
            setLoading(true);
            api(SERVICE.getPayrollAdvisors + `?date=${fecha}&centralOfficeId=${sucursalSelect.value}`)
                .then((data) => {
                    let arrayTemp = [];
                    if (data.data && data.data.data) {
                        arrayTemp = data.data.data.map((row, index) => ({
                            ...row,
                            id: index,
                            rowNumber: index + 1
                        }));
                    }
                    setDataTable(arrayTemp);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                    Swal.fire('Error', 'No se pudo cargar la información de nómina', 'error');
                })
        }
    }, [fecha, sucursalSelect]);

    const columns = [
        {
            name: '#',
            selector: row => row.rowNumber,
            width: '70px',
            center: true
        },
        {
            name: 'Nombre Completo',
            selector: row => row.asesor,
            wrap: true,
            flex:1
        },
        {
            name: 'Alias',
            selector: row => row.aliasAsesor,
            minWidth: '140px'
        },
        {
            name: 'Préstamos por Pagar',
            selector: row => row.cantidadPrestamoPorPagar,
            wrap: true,
            cell: (row) => (
                <div style={{ width: '100%', textAlign: 'center' }}>
                    <span className='badge bg-primary'>{row.cantidadPrestamoPorPagar}</span>
                </div>
            ),
            minWidth: '160px',
            center: true
        },
        {
            name: 'Nómina Anterior',
            selector: row => row.nominaAnterior,
            wrap: true,
            cell: (row) => (
                <div style={{ width: '100%', textAlign: 'right' }}>
                    {row.nominaAnterior ? `$ ${row.nominaAnterior.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$ 0.00'}
                </div>
            ),
            minWidth: '170px',
            right: true
        },
        {
            name: 'Nómina Actual',
            selector: row => row.nominaActual,
            wrap: true,
            cell: (row) => (
                <div style={{ width: '100%', textAlign: 'right' }}>
                    {row.nominaActual ? `$ ${row.nominaActual.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$ 0.00'}
                </div>
            ),
            minWidth: '170px',
            right: true
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                        <button
                            className='btn btn-sm btn-primary'
                            title='Editar nómina'
                            onClick={() => handleEditNomina(row)}
                        >
                            <MdEdit />
                        </button>
                        {row.nominaActualId && (
                            <button
                                className='btn btn-sm btn-danger'
                                title='Eliminar nómina'
                                onClick={() => handleDeleteNomina(row.nominaActualId)}
                            >
                                <MdDelete />
                            </button>
                        )}
                    </div>
                );
            },
            minWidth: '130px',
            center: true
        },
    ];

    const handleEditNomina = (row) => {
        let advisorId = asesoresMap[row.aliasAsesor.toLowerCase()];
        if (!advisorId) {
            advisorId = asesoresMap[row.asesor.toLowerCase()];
        }

        if (!advisorId) {
            Swal.fire('Error', 'No se encontró el ID del asesor', 'error');
            return;
        }

        setSelectedAdvisor(row);
        setSelectedAdvisorId(advisorId);
        setDetailLoading(true);
        setShowDetailModal(true);

        api(SERVICE.getPayrollAdvisorsDetails + `?date=${fecha}&centralOfficeId=${sucursalSelect.value}&advisorId=${advisorId}`)
            .then((data) => {
                let arrayTemp = [];
                if (data.data && data.data.data) {
                    arrayTemp = data.data.data.map((item, index) => ({
                        ...item,
                        id: index
                    }));
                }
                setDetailData(arrayTemp);
                setDetailLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setDetailLoading(false);
                Swal.fire('Error', 'No se pudo cargar el detalle de la nómina', 'error');
            })
    }

    const handleNominaSaveSuccess = () => {
        setShowDetailModal(false);
        handleUpdate();
    }

    const handleDeleteNomina = (id) => {
        Swal.fire({
            title: '¿Está seguro que desea eliminar la nómina?',
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#dc3545'
        }).then((result) => {
            if (result.isConfirmed) {
                api(SERVICE.deletePayrollAdvisors + `?Id=${id}`, null, 'DELETE')
                    .then(() => {
                        Swal.fire('Eliminada', 'La nómina ha sido eliminada', 'success');
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire('Error', 'No se pudo eliminar la nómina', 'error');
                    });
            }
        });
    }

    useEffect(() => {
        handleGetSucursales();
        handleGetAsesores();
    }, []);

    useEffect(() => {
        handleUpdate();
    }, [fecha, sucursalSelect, handleUpdate]);

    return (
        <>
            <WindowLayout
                title='NÓMINA'
                route={['Inicio', 'Nómina']}
                actions={[() => setMenuActual('homeMenu')]}
                icon={<MdAttachMoney />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerInputs} style={{ display: 'flex', justifyContent: 'left' }}>
                        <div className={styles.itemFormInputs} style={{ zIndex: 3 }}>
                            <label className='form-label'>Sucursal: </label>
                            <Select
                                isClearable={true}
                                options={sucursales}
                                placeholder='Seleccione...'
                                value={sucursalSelect}
                                onChange={(e) => setSucursalSelect(e)}
                            />
                        </div>
                        <div className={styles.itemFormInputs} style={{ zIndex: 2 }}>
                            <label className='form-label'>Fecha: </label>
                            <input
                                type='date'
                                className='form-control'
                                placeholder='Fecha'
                                value={fecha}
                                onChange={(e) => setFecha(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={styles.tableContainer}>
                        {loading ? (
                            <div className={styles.loadingContainer}>
                                <h5>Cargando...</h5>
                                <div className='spinner-border text-primary' role='status'>
                                    <span className='visually-hidden'>Loading...</span>
                                </div>
                            </div>
                        ) : sucursalSelect === null || fecha === '' || fecha === null ? (
                            <div className={styles.noDataContainer}>
                                <h5>Seleccione una sucursal y una fecha para ver la nómina.</h5>
                            </div>
                        ) : dataTable.length === 0 ? (
                            <div className={styles.noDataContainer}>
                                <h5>No se encontró información de nómina para esta fecha y sucursal.</h5>
                            </div>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={dataTable}
                                customStyles={APP_OPTIONS.TABLE_SETTING}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                persistTableHead
                                fixedHeader
                                fixedHeaderScrollHeight='600px'
                                responsive
                            />
                        )}
                    </div>
                </div>
            </WindowLayout>

            <NominaModal
                show={showDetailModal}
                setShow={setShowDetailModal}
                selectedAdvisor={selectedAdvisor}
                detailData={detailData}
                setDetailData={setDetailData}
                detailLoading={detailLoading}
                fecha={fecha}
                sucursalSelect={sucursalSelect}
                advisorId={selectedAdvisorId}
                onSave={handleNominaSaveSuccess}
            />
        </>
    );
}
